VjsAdmin.PricePerSeatCalculator = (function () {
    let selectedPricing = {};
    const init = function () {
        set2022Pricing();
        $('#pricing-model').change(function () {
            if (this.value === 'pricing-model-2022') set2022Pricing();
            if (this.value === 'pricing-model-2021') set2021Pricing();
        });

        $('.quote-num-students').on('keyup', function () {
            setCalculation(this.id);
        });
    };

    function setCalculation(quoteNum) {
        const numStudents = $(`#${quoteNum}`).val();

        if (numStudents === '' || numStudents == null) {
            $(this).closest('.card').find('.quote-price-per-seat').text('---');
            $(this).closest('.card').find('.quote-subtotal').text('---');
        } else {
            let pricePerStudent = selectedPricing.coeffecientOne * numStudents ** (1 / selectedPricing.radical)
                + selectedPricing.coeffecientTwo * numStudents
                + selectedPricing.coeffecientThree;
            pricePerStudent = parseFloat(pricePerStudent);
            pricePerStudent /= numStudents;

            if (pricePerStudent > selectedPricing.upperLimit) {
                pricePerStudent = parseFloat(selectedPricing.upperLimit);
            }

            if (pricePerStudent < selectedPricing.lowerLimit) {
                pricePerStudent = selectedPricing.lowerLimit;
            }

            // allows us to keep all math exactly the same and increase total by a percentage.
            pricePerStudent = (Math.round(pricePerStudent * selectedPricing.increase * 100) / 100).toFixed(2);

            const subtotal = commaSeparateNumber((pricePerStudent * numStudents).toFixed(2));
            $(`#${quoteNum}`).closest('.card').find('.quote-price-per-seat').text(pricePerStudent);
            $(`#${quoteNum}`).closest('.card').find('.quote-subtotal').text(subtotal);
        }
    }

    function commaSeparateNumber(val) {
        let formatted = val;
        while (/(\d+)(\d{3})/.test(formatted.toString())) {
            formatted = formatted.toString().replace(/(\d+)(\d{3})/, '$1,$2');
        }
        return formatted;
    }

    // this used to be Legacy.
    function set2021Pricing() {
        const pricing2021 = {
            coeffecientOne: 142,
            coeffecientTwo: 0.92,
            coeffecientThree: 0,
            radical: 1.479,
            lowerLimit: 5,
            upperLimit: 40,
            increase: 1.0,
        };

        selectedPricing = pricing2021;
        $('.pricing-header').text('2021 Pricing');
        setCalculation('quote-1-num-students');
        setCalculation('quote-2-num-students');
    }

    // This used to be 2020, now it's current / 2022
    function set2022Pricing() {
        const currentPricing = {
            coeffecientOne: 142,
            coeffecientTwo: 0.92,
            coeffecientThree: 0,
            radical: 1.479,
            lowerLimit: 5,
            upperLimit: 40,
            increase: 1.1,
        };

        selectedPricing = currentPricing;
        $('.pricing-header').text('2022 Pricing');
        setCalculation('quote-1-num-students');
        setCalculation('quote-2-num-students');
    }

    return {
        init,
    };
}());
